import { Plus, X } from "lucide-react";

import { Input } from "@/app/admin/_common/ui/input";

export default function SelectOptionsInput({
  options,
  onChange,
}: {
  options: string[];
  onChange: (options: string[]) => void;
}) {
  const setAt = (index: number, value: string) =>
    onChange(options.map((o, i) => (i === index ? value : o)));

  return (
    <div className="flex flex-col gap-1.5">
      {options.map((option, index) => (
        <div key={index} className="flex items-center gap-1.5">
          <Input
            value={option}
            placeholder={`Option ${index + 1}`}
            onChange={(e) => setAt(index, e.target.value)}
            className="h-8 max-w-[280px]"
          />
          <button
            type="button"
            onClick={() => onChange(options.filter((_, i) => i !== index))}
            className="flex size-6 items-center justify-center rounded-md text-muted-foreground hover:bg-muted"
            aria-label="Remove option"
          >
            <X className="size-3.5" />
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={() => onChange([...options, ""])}
        className="flex w-fit items-center gap-1 text-[12.5px] text-muted-foreground hover:text-foreground"
      >
        <Plus className="size-3.5" />
        Add option
      </button>
    </div>
  );
}
